// extracted by mini-css-extract-plugin
module.exports = {"pagination-current":"SwiperItem_pagination-current__uApJO"};